<template>
  <page-header-wrapper>
    <!-- <JeepayCard title="结算记录查询"> -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" class="table-head-ground">
        <div class="table-layer">
          <!-- 时间筛选器 -->
          <a-form-item
            label=""
            style="max-width: 520px; min-width:400px"
          >
            <time-range-filter
              :default-type="'today'"
              @change="handleTimeRangeChange"
            />
          </a-form-item>
          <a-form-item label="">
            <jeepay-text-up
              :placeholder="'账户名'"
              :msg="searchData.accountName"
              v-model="searchData.accountName"
            />
          </a-form-item>
          <a-form-item label="">
            <jeepay-text-up
              :placeholder="'结算单ID'"
              :msg="searchData.settlementNo"
              v-model="searchData.settlementNo"
            />
          </a-form-item>

          <a-form-item label="" >
            <a-select
              v-model="searchData.statusList"
              placeholder="结算状态"
              mode="multiple"
              allowClear
              style="width: 150px"
            >
              <!-- <a-select-option value="">全部</a-select-option> -->
              <a-select-option value="100">等待审核</a-select-option>
              <a-select-option value="200">已审核</a-select-option>
              <a-select-option value="300">打款中</a-select-option>
              <a-select-option value="400">打款成功</a-select-option>
              <a-select-option value="500">打款失败</a-select-option>
              <a-select-option value="600">审核不通过</a-select-option>
            </a-select>
          </a-form-item>
          <span class="table-page-search-submitButtons">
            <a-button
              type="primary"
              icon="search"
              @click="queryFunc"
              :loading="btnLoading"
            >搜索</a-button>
            <a-button
              style="margin-left: 8px"
              icon="reload"
              @click="resetForm"
            >重置</a-button>
          </span>
        </div>
      </a-form>
    </div>

    <!-- 统计信息 -->
    <div class="summary-info">
      <!-- 前端计算 -->
      <span>订单数: {{ summaryData.orderCount }}</span>
      <span style="margin-left: 20px;">结算金额: {{ formatAmount(summaryData.totalAmount, '¥') }}</span>
    </div>

    <!-- 列表渲染 -->
    <JeepayTable
      @btnLoadClose="btnLoading = false"
      ref="infoTable"
      :initData="true"
      :reqTableDataFunc="reqTableDataFunc"
      :tableColumns="tableColumns"
      :searchData="searchData"
      rowKey="id"
      :tableRowCrossColor="true"
      @change="handleTableChange"
    >
      <template slot="settlementAmountSlot" slot-scope="{ record }">
        <b style="color: #1890ff;">{{ formatAmount(record.settlementAmount, '¥') }}</b>
      </template>

      <template slot="paymentAmountSlot" slot-scope="{ record }">
        <b style="color: #52c41a;">{{ formatAmount(record.amountPaid, '¥') }}</b>
      </template>

      <template slot="feeSlot" slot-scope="{ record }">
        <span style="color: #fa8c16;">{{ formatAmount(record.fee, '¥') }}</span>
      </template>

      <template slot="accountTypeSlot" slot-scope="{ record }">
        <a-tag :color="getAccountTypeColor(record.accountType)">
          {{ getAccountTypeText(record.accountType) }}
        </a-tag>
      </template>

      <template slot="statusSlot" slot-scope="{ record }">
        <a-tag :color="getStatusColor(record.status)">
          {{ getStatusText(record.status) }}
        </a-tag>
      </template>

      <template slot="settlementDateSlot" slot-scope="{ record }">
        {{ formateDate(record) }}
      </template>

      <template slot="opSlot" slot-scope="{ record }">
        <JeepayTableColumns>
          <a-button type="link" @click="viewDetail(record)">详情</a-button>
        </JeepayTableColumns>
      </template>
    </JeepayTable>
    <!-- </JeepayCard> -->

    <!-- 详情弹窗组件 -->
    <SettlementDetailModal
      :visible="detailVisible"
      :detailData="detailData"
      @cancel="handleDetailCancel"
    />
  </page-header-wrapper>
</template>

<script>
import JeepayCard from '@/components/JeepayCard/JeepayCard'
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTableColumns from '@/components/JeepayTable/JeepayTableColumns'
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp'
import SettlementDetailModal from './components/SettlementDetailModal'
import TimeRangeFilter from '@/components/TimeRangeFilter'
import moment from 'moment'
import { req } from '@/api/manage'
import { API_URL_SETTLEMENT_APPLICATION_LIST, getSettlementApplicationDetail } from '@/api/settlement'
import { formatAmount } from '@/utils/util'

const tableColumns = [
  {
    key: 'settlementNo',
    title: '结算单号',
    dataIndex: 'settlementNo',
    width: 280
  },
  {
    key: 'accountName',
    title: '账户名',
    dataIndex: 'accountName',
    width: 120
  },
  {
    key: 'settlementAmount',
    title: '结算金额',
    scopedSlots: { customRender: 'settlementAmountSlot' },
    width: 120,
    sorter: true
  },
  {
    key: 'amountPaid',
    title: '打款金额',
    scopedSlots: { customRender: 'paymentAmountSlot' },
    width: 120,
    sorter: true
  },
  {
    key: 'fee',
    title: '手续费',
    scopedSlots: { customRender: 'feeSlot' },
    width: 100
  },
  {
    key: 'accountType',
    title: '账户类型',
    scopedSlots: { customRender: 'accountTypeSlot' },
    width: 120
  },
  {
    key: 'status',
    title: '结算状态',
    scopedSlots: { customRender: 'statusSlot' },
    width: 100
  },
  {
    key: 'settlementDate',
    title: '结算日期',
    dataIndex: 'settlementDate',
    scopedSlots: { customRender: 'settlementDateSlot' },
    width: 180,
    sorter: true
  },
  {
    key: 'op',
    title: '操作',
    scopedSlots: { customRender: 'opSlot' },
    width: 80,
    fixed: 'right'
  }
]

export default {
  name: 'SettlementList',
  components: {
    JeepayCard,
    JeepayTable,
    JeepayTableColumns,
    JeepayTextUp,
    SettlementDetailModal,
    TimeRangeFilter
  },
  data () {
    return {
      btnLoading: false,
      tableColumns: tableColumns,
      searchData: {
        startTime: '',
        endTime: '',
        accountName: '',
        settlementNo: '',
        statusList: []
      },
      detailVisible: false,
      detailData: {},
      summaryData: {
        orderCount: 0,
        totalAmount: '0.00'
      }
    }
  },
  computed: {
    dateRange () {
      const { startTime, endTime } = this.searchData
      if (startTime && endTime && startTime !== '' && endTime !== '') {
        // 验证时间戳是否有效
        const startMoment = moment(startTime)
        const endMoment = moment(endTime)
        if (startMoment.isValid() && endMoment.isValid()) {
          return [startMoment, endMoment]
        }
      }
      return []
    },
    totalAmount () {
      return this.summaryData.totalAmount
    }
  },
  methods: {
    // 处理时间范围变化
    handleTimeRangeChange (timeData) {
      this.searchData.startTime = timeData.startTime
      this.searchData.endTime = timeData.endTime
    },

    queryFunc () {
      this.btnLoading = true
      this.$refs.infoTable.refTable(true)
    },

    // 请求table接口数据
    async reqTableDataFunc (params) {
      try {
        // 处理statusList：过滤空字符串，如果为['']则转化成[]
        let processedStatusList = this.searchData.statusList || []
        if (Array.isArray(processedStatusList)) {
          processedStatusList = processedStatusList.filter(status => status !== '' && status !== null && status !== undefined)
        }

        // 构建查询参数
        const queryParams = {
          ...params,
          // mchId: this.searchData.mchId, // 强制包含商户ID
          startTime: this.searchData.startTime,
          endTime: this.searchData.endTime,
          accountName: this.searchData.accountName,
          settlementNo: this.searchData.settlementNo,
          statusList: processedStatusList
        }
        const response = await req.getList(API_URL_SETTLEMENT_APPLICATION_LIST, queryParams)
         // 合并账户信息到结算记录
        // 统计 订单数量，已经列表结算金额
        // 计算汇总数据
        this.calculateSummary(response.records)
        return response
      } catch (error) {
        console.error('查询结算记录失败:', error)
        throw error
      }
    },
    // 批量查询账户信息
    async batchQueryAccountInfo (accountIds) {
      if (!accountIds.length) return {}

      // 模拟批量查询账户信息API
      return new Promise((resolve) => {
        setTimeout(() => {
          const mockAccountInfo = {
            ACC001: {
              accountName: '张三',
              bankName: '工商银行',
              ifscCode: 'ICICI0001234',
              accountNumber: '6222021234567890'
            },
            ACC002: {
              accountName: '李四',
              bankName: 'USDT(TRC20)',
              ifscCode: '',
              accountNumber: 'TQn9Y2khEsLJW1ChVWFMSMeRDow5oNDMnt'
            },
            ACC003: {
              accountName: '王五',
              bankName: 'HDFC Bank',
              ifscCode: 'HDFC0001234',
              accountNumber: '1234567890123456'
            }
          }
          resolve(mockAccountInfo)
        }, 200)
      })
    },

    // 计算汇总数据
    calculateSummary (records) {
      this.summaryData.orderCount = records.length
      this.summaryData.totalAmount = records.reduce((sum, record) => {
        return sum + parseFloat(record.settlementAmount || 0)
      }, 0).toFixed(2)
    },

    // 根据结算记录主键ID查询详情
    async querySettlementDetail (id) {
      try {
        // 模拟API调用
        const response = await getSettlementApplicationDetail(id)
        return response
      } catch (error) {
        console.error('查询结算详情失败:', error)
        throw error
      }
    },

    resetForm () {
      this.searchData = {
        startTime: '',
        endTime: '',
        accountName: '',
        settlementNo: '',
        statusList: []
      }

      // 使用 $nextTick 确保数据更新后再执行查询
      this.$nextTick(() => {
        this.queryFunc()
      })
    },

    // 获取状态文本
    getStatusText (status) {
      // 结算状态 100-等待审核, 200-已审核, 300-打款中, 400-打款成功, 500-打款失败, 600-审核不通过
      console.log('status', status)
      const statusMap = {
        100: '等待审核',
        200: '已审核',
        300: '打款中',
        400: '打款成功',
        500: '打款失败',
        600: '审核不通过'
      }
      return statusMap[Number(status)] || '未知'
    },

    // 获取状态颜色
    getStatusColor (status) {
      const colorMap = {
        100: 'orange',
        200: 'green',
        300: 'blue',
        400: 'green',
        500: 'red',
        600: '#ff4d4f'
      }
      return colorMap[status] || 'default'
    },

    // 获取账户类型文本
    getAccountTypeText (type) {
      const typeMap = {
        1: '银行账户',
        2: 'USDT(TRC20)'
      }
      return typeMap[type] || '未知'
    },

    // 获取账户类型颜色
    getAccountTypeColor (type) {
      const colorMap = {
        1: 'blue',
        2: 'purple'
      }
      return colorMap[type] || 'default'
    },

    // 查看详情
    async viewDetail (record) {
      try {
        const detailData = await this.querySettlementDetail(record.id)
        this.detailData = detailData
        this.detailVisible = true
      } catch (error) {
        this.$message.error('获取详情失败')
      }
    },

    // 关闭详情弹窗
    handleDetailCancel () {
      this.detailVisible = false
      this.detailData = {}
    },

    // 表格变化处理
    handleTableChange (pagination, filters, sorter) {
      // 处理排序等
      console.log('表格变化:', { pagination, filters, sorter })
    },

    moment,

    formateDate: function (date) {
      console.log('date》〉》〉', date, typeof date)
      if (!date || date === '' || date === null || date === undefined) {
        return '--'
      }

      // 处理不同类型的时间戳
      let processedDate = date

      // 如果是字符串数字，转换为数字
      if (typeof date === 'string' && !isNaN(date)) {
        processedDate = parseInt(date)
      }

      // 如果是10位时间戳（秒），转换为13位（毫秒）
      if (typeof processedDate === 'number' && processedDate.toString().length === 10) {
        processedDate = processedDate * 1000
      }

      const momentDate = moment(processedDate)
      console.log('processedDate》〉》〉', processedDate, 'momentDate》〉》〉', momentDate, 'isValid:', momentDate.isValid())

      if (!momentDate.isValid()) {
        return '--'
      }

      return momentDate.format('YYYY-MM-DD HH:mm:ss')
    },

    // 格式化金额显示（带千分位）
    formatAmount
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.summary-info {
  margin-bottom: 16px;
  padding: 12px 16px;
  background-color: #f0f2f5;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
</style>
